import { Instance } from './instance.model';

export class User {
  static ROLE_ADMIN = 'admin';
  static ROLE_INSTANCE_CONFIGURATOR = 'instance-configurator';
  static ROLE_MARKETER = 'marketer';
  static ROLE_CLIENT_ADMIN = 'client-admin';
  static ROLE_PROPERTY_MANAGER = 'property-manager';

  static ALL_ROLES = [
    User.ROLE_ADMIN,
    User.ROLE_INSTANCE_CONFIGURATOR,
    User.ROLE_CLIENT_ADMIN,
    User.ROLE_MARKETER,
    User.ROLE_PROPERTY_MANAGER
  ];

  id!: number;
  name!: string;
  email!: string;
  instanceId!: number | null;
  primaryRole?: string;
  primaryRoleId?: number;
  profileImageId?: number;
  profileImageUrl?: string | null;
  activatedAt?: string | null;
  instance?: Instance;
  instances: Instance[] = [];
  canChangeRole = true;

  constructor(data?: Partial<any>) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.email = data['email'];
      this.instanceId = data['instanceId'] ?? null;
      this.primaryRole = data['primaryRole']?.['name'] ?? null;
      this.primaryRoleId = data['primaryRole']?.['id'] ?? null;
      this.profileImageId = data['profileImage']?.['id'] ?? null;
      this.profileImageUrl = data['profileImage']?.['url'] ?? null;
      this.activatedAt = data['activatedAt'] ?? null;
      this.instance = data['instance'] ? new Instance(data['instance']) : undefined;
      this.instances = (data['instances'] ?? []).map((i: any) => new Instance(i));
      this.canChangeRole = data['canChangeRole'] ?? true;
    }
  }

  get instanceIds(): number[] {
    return this.instances.map(i => i.id);
  }

  hasMultipleInstances(): boolean {
    return this.instances.length > 1;
  }

  isAdmin(): boolean {
    return this.primaryRole === User.ROLE_ADMIN;
  }

  canSwitchInstances(): boolean {
    return this.primaryRole === User.ROLE_ADMIN || this.primaryRole === User.ROLE_INSTANCE_CONFIGURATOR;
  }

  get isActivated(): boolean {
    return !!this.activatedAt;
  }

  get roleClass(): string {
    switch (this.primaryRole) {
      case User.ROLE_ADMIN:
        return 'badge-primary';
      case User.ROLE_INSTANCE_CONFIGURATOR:
        return 'badge-info';
      case User.ROLE_CLIENT_ADMIN:
        return 'badge-success';
      case User.ROLE_PROPERTY_MANAGER:
        return 'badge-warning';
      default:
        return 'bg-secondary';
    }
  }
}

export class UserFilters {
  search: string | null = null;
  role: string | null = null;

  constructor(data?: Partial<UserFilters>) {
    if (data) Object.assign(this, data);
  }

  getFilterQuery(): Record<string, any> {
    const query: Record<string, any> = {};

    if (this.search) {
      query['search'] = this.search;
    }
    if (this.role) {
      query['role'] = this.role;
    }

    return query;
  }

  get hasActiveFilters(): boolean {
    return !!(this.search || this.role);
  }

  reset(): void {
    this.search = null;
    this.role = null;
  }
}
